import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import {
  RANK_SYMBOL_TO_STR,
  ROLE_SYMBOL_TO_STR,
} from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import Synergies from "@/game-lol/models/lol-synergies.mjs";
import { getQueueDetails } from "@/game-lol/utils/symbol-queue.mjs";
import { RankSymbol } from "@/game-lol/utils/symbol-rank.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function querySynergies(variables: {
  region?: string;
  tier?: string;
  queue: string;
  championId?: number;
  role1: string;
  role2: string;
}) {
  const params = {
    region: variables?.region,
    tier: RANK_SYMBOL_TO_STR[RankSymbol(variables?.tier)].gql,
    queue: getQueueDetails(variables.queue)?.gql,
    championId: null,
    role1: ROLE_SYMBOL_TO_STR[RoleSymbol(variables?.role1)]?.gql,
    role2: ROLE_SYMBOL_TO_STR[RoleSymbol(variables?.role2)]?.gql,
  };

  if (variables.championId) {
    params.championId = variables.championId;
  } else if (!params.championId) {
    delete params.championId;
  }

  if (variables.region) {
    params.region = variables.region;
  } else if (!params.region) {
    delete params.region;
  }

  return queryGQL(
    appURLs.DATALAKE,
    GraphQLTemplatesDatalake.RoleSynergies,
    params,
  );
}

export default function ({
  filters,
  urlParams,
  options = {},
}: {
  filters: {
    region?: string;
    queue: string;
    tier: string;
    championId?: number;
    role: string;
    duoRole: string;
  };
  urlParams: URLSearchParams;
  options?: object;
}) {
  return getData(
    querySynergies({
      region: filters.region,
      queue: filters.queue,
      tier: filters.tier,
      championId: filters.championId,
      role1: filters.role,
      role2: filters.duoRole,
    }),
    Synergies,
    ["lol", "championSynergies", urlParams.toString()],
    {
      ...options,
    },
  );
}
